import {Grid, Stack, Typography} from '@mui/material'
import FormTextField from 'src/components/ui/TextField'
import AutoComplete, {AutocompleteOption} from 'src/components/ui/AutoComplete'
import {useFormContext} from 'react-hook-form'
import Select from 'src/components/ui/Select'
import {IndificationType} from 'src/enum/indificationType'

interface ContactDetailsProps {
  cities: any[]
  indificationTypes: any[]
}

const ContactDetails = ({cities, indificationTypes}: ContactDetailsProps) => {
  const {setValue, watch} = useFormContext()
  const indificationTypeId = watch('contact.indificationTypeID')

  const onChangeCityName = (newValue: AutocompleteOption | null) => {
    setValue('contact.city', newValue?.label)
  }

  return (
    <Stack direction="column" spacing={2}>
      <Typography variant="h6">פרטי מגיש הבקשה:</Typography>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <FormTextField name="contact.firstName" label="שם פרטי" />
        </Grid>
        <Grid item xs={3}>
          <FormTextField name="contact.lastName" label="שם משפחה" />
        </Grid>
        <Grid item xs={2}>
          <Select
            name="contact.indificationTypeID"
            label="סוג הזדהות"
            options={indificationTypes}
          />
        </Grid>
        <Grid item xs={4}>
          {(!indificationTypeId ||
            indificationTypeId === IndificationType.IndificationNo) && (
            <FormTextField
              name="contact.indificationNo"
              label="מספר תעודת זהות"
            />
          )}
          {indificationTypeId === IndificationType.Passport && (
            <FormTextField name="contact.passport" label="מספר דרכון" />
          )}
        </Grid>

        <Grid item xs={3}>
          <FormTextField name="contact.street" label="רחוב" />
        </Grid>
        <Grid item xs={1}>
          <FormTextField name="contact.houseNumber" label="מס’ בית" />
        </Grid>
        <Grid item xs={3}>
          <AutoComplete
            options={cities}
            name="contact.city"
            label={'עיר'}
            onChange={onChangeCityName}
            getValue={o => o?.label}
          />
        </Grid>
        <Grid item xs={2}>
          <FormTextField name="contact.zipCode" label="מיקוד" />
        </Grid>
        <Grid item xs={3}>
          <FormTextField name="contact.phone" label="טלפון" />
        </Grid>

        <Grid item xs={4}>
          <FormTextField name="contact.cellPhone" label="טלפון נייד" />
        </Grid>
        <Grid item xs={4}>
          <FormTextField name="contact.email" label="מייל" />
        </Grid>
        <Grid item xs={4}>
          <FormTextField name="contact.title" label="תפקיד במוסד" />
        </Grid>
      </Grid>
    </Stack>
  )
}

export default ContactDetails
